import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=6fa2a198&scoped=true"
import script from "./PageOne.vue?vue&type=script&lang=js"
export * from "./PageOne.vue?vue&type=script&lang=js"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=6fa2a198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2a198",
  null
  
)

export default component.exports